import styled from "styled-components";

import { ToolbarContainer } from "@Console/components/molecules/DataTable/atoms/Toolbar/styles";

export const DashboardSubscriptionTableSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${ToolbarContainer} {
    padding: 0 1rem;

    .MuiTablePagination-actions > .MuiButtonBase-root.MuiIconButton-root {
      height: 2rem;
      width: 2rem;
    }

    .MuiTablePagination-toolbar {
      min-height: 3rem;
    }
  }

  .MuiTablePagination-root {
    display: none;
  }

  .MuiDataGrid-root
    .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)
    > .MuiDataGrid-cell {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: horizontal;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MuiDataGrid-columnHeaders.MuiDataGrid-withBorderColor {
    min-height: 2rem !important;
    max-height: 2rem !important;
  }

  @media (max-width: 650px) {
    [data-field="id"] {
      display: none !important;
    }
  }
`;

export const DashboardSubscriptionTableSectionTitle = styled.h3`
  all: unset;
  font: 600 1.125rem/1.406rem "Inter";
  color: ${({ theme }) => theme.console.pageTitleColor} !important;
`;
